import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/inactive/HomePageOne";
import HomePageTwo from "./pages/HomePageTwo";
import HomePageThree from "./pages/inactive/HomePageThree";
import HomePageFour from "./pages/inactive/HomePageFour";
import HomePageFive from "./pages/inactive/HomePageFive";
import HomePageSix from "./pages/inactive/HomePageSix";
import HomePageSeven from "./pages/inactive/HomePageSeven";
import EmailPage from "./pages/inactive/EmailPage";
import AddUserPage from "./pages/inactive/AddUserPage";
import AlertPage from "./pages/inactive/AlertPage";
import AssignRolePage from "./pages/inactive/AssignRolePage";
import AvatarPage from "./pages/inactive/AvatarPage";
import BadgesPage from "./pages/inactive/BadgesPage";
import ButtonPage from "./pages/inactive/ButtonPage";
import CalendarMainPage from "./pages/inactive/CalendarMainPage";
import CardPage from "./pages/inactive/CardPage";
import CarouselPage from "./pages/inactive/CarouselPage";
import ChatEmptyPage from "./pages/inactive/ChatEmptyPage";
import ChatMessagePage from "./pages/inactive/ChatMessagePage";
import ChatProfilePage from "./pages/inactive/ChatProfilePage";
import CodeGeneratorNewPage from "./pages/inactive/CodeGeneratorNewPage";
import CodeGeneratorPage from "./pages/inactive/CodeGeneratorPage";
import ColorsPage from "./pages/inactive/ColorsPage";
import ColumnChartPage from "./pages/inactive/ColumnChartPage";
import CompanyPage from "./pages/CompanyPage";
import CurrenciesPage from "./pages/inactive/CurrenciesPage";
import DropdownPage from "./pages/inactive/DropdownPage";
import ErrorPage from "./pages/inactive/ErrorPage";
import FaqPage from "./pages/inactive/FaqPage";
import ForgotPasswordPage from "./pages/inactive/ForgotPasswordPage";
import FormLayoutPage from "./pages/inactive/FormLayoutPage";
import FormValidationPage from "./pages/inactive/FormValidationPage";
import FormPage from "./pages/inactive/FormPage";
import GalleryPage from "./pages/inactive/GalleryPage";
import ImageGeneratorPage from "./pages/inactive/ImageGeneratorPage";
import ImageUploadPage from "./pages/inactive/ImageUploadPage";
import InvoiceAddPage from "./pages/inactive/InvoiceAddPage";
import InvoiceEditPage from "./pages/inactive/InvoiceEditPage";
import InvoiceListPage from "./pages/InvoiceListPage";
import InvoicePreviewPage from "./pages/InvoicePreviewPage";
import KanbanPage from "./pages/inactive/KanbanPage";
import LanguagePage from "./pages/inactive/LanguagePage";
import LineChartPage from "./pages/inactive/LineChartPage";
import ListPage from "./pages/inactive/ListPage";
import MarketplaceDetailsPage from "./pages/inactive/MarketplaceDetailsPage";
import MarketplacePage from "./pages/inactive/MarketplacePage";
import NotificationAlertPage from "./pages/inactive/NotificationAlertPage";
import NotificationPage from "./pages/inactive/NotificationPage";
import PaginationPage from "./pages/inactive/PaginationPage";
import PaymentGatewayPage from "./pages/inactive/PaymentGatewayPage";
import PieChartPage from "./pages/inactive/PieChartPage";
import PortfolioPage from "./pages/inactive/PortfolioPage";
import PricingPage from "./pages/inactive/PricingPage";
import ProgressPage from "./pages/inactive/ProgressPage";
import RadioPage from "./pages/inactive/RadioPage";
import RoleAccessPage from "./pages/inactive/RoleAccessPage";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/inactive/SignUpPage";
import StarRatingPage from "./pages/inactive/StarRatingPage";
import StarredPage from "./pages/inactive/StarredPage";
import SwitchPage from "./pages/inactive/SwitchPage";
import TableBasicPage from "./pages/inactive/TableBasicPage";
import TableDataPage from "./pages/inactive/TableDataPage";
import TabsPage from "./pages/inactive/TabsPage";
import TagsPage from "./pages/inactive/TagsPage";
import TermsConditionPage from "./pages/inactive/TermsConditionPage";
import TextGeneratorPage from "./pages/inactive/TextGeneratorPage";
import ThemePage from "./pages/inactive/ThemePage";
import TooltipPage from "./pages/inactive/TooltipPage";
import TypographyPage from "./pages/inactive/TypographyPage";
import UsersGridPage from "./pages/inactive/UsersGridPage";
import UsersListPage from "./pages/UsersListPage";
import ViewDetailsPage from "./pages/inactive/ViewDetailsPage";
import VideoGeneratorPage from "./pages/inactive/VideoGeneratorPage";
import VideosPage from "./pages/inactive/VideosPage";
import ViewProfilePage from "./pages/inactive/ViewProfilePage";
import VoiceGeneratorPage from "./pages/inactive/VoiceGeneratorPage";
import WalletPage from "./pages/WalletPage";
import WidgetsPage from "./pages/inactive/WidgetsPage";
import WizardPage from "./pages/inactive/WizardPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import TextGeneratorNewPage from "./pages/inactive/TextGeneratorNewPage";
import HomePageEight from "./pages/inactive/HomePageEight";
import HomePageNine from "./pages/inactive/HomePageNine";
import HomePageTen from "./pages/inactive/HomePageTen";
import HomePageEleven from "./pages/inactive/HomePageEleven";
import GalleryGridPage from "./pages/inactive/GalleryGridPage";
import GalleryMasonryPage from "./pages/inactive/GalleryMasonryPage";
import GalleryHoverPage from "./pages/inactive/GalleryHoverPage";
import BlogPage from "./pages/inactive/BlogPage";
import BlogDetailsPage from "./pages/inactive/BlogDetailsPage";
import AddBlogPage from "./pages/inactive/AddBlogPage";
import TestimonialsPage from "./pages/inactive/TestimonialsPage";
import ComingSoonPage from "./pages/inactive/ComingSoonPage";
import AccessDeniedPage from "./pages/inactive/AccessDeniedPage";
import MaintenancePage from "./pages/inactive/MaintenancePage";
import BlankPagePage from "./pages/inactive/BlankPagePage";

import ProtectedRoute from "./components/ProtectedRoute";
import GuestRoute from "./components/GuestRoute";
import DepositPage from "./pages/DepositPage";
import DepositDetailPage from "./pages/DepositDetailPage";
import TransactionDetailPage from "./pages/inactive/TransactionDetailPage";
import TransactionByUserPage from "./pages/inactive/TransactionByUserPage";
import DepositByUserPage from "./pages/DepositByUserPage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        {/* <Route exact path="/index-2" element={<HomePageOne />} /> */}
        <Route
          exact
          path="/"
          element={
            <ProtectedRoute>
              <HomePageTwo />
            </ProtectedRoute>
          }
        />

        <Route
          exact
          path="/company"
          element={
            <ProtectedRoute>
              <CompanyPage />
            </ProtectedRoute>
          }
        />

        {/* <Route exact path="/index-3" element={<HomePageThree />} />
        <Route exact path="/index-4" element={<HomePageFour />} />
        <Route exact path="/index-5" element={<HomePageFive />} />
        <Route exact path="/index-6" element={<HomePageSix />} />
        <Route exact path="/index-7" element={<HomePageSeven />} />
        <Route exact path="/index-8" element={<HomePageEight />} />
        <Route exact path="/index-9" element={<HomePageNine />} />
        <Route exact path="/index-10" element={<HomePageTen />} />
        <Route exact path="/index-11" element={<HomePageEleven />} /> */}

        {/* SL */}
        {/* <Route exact path="/add-user" element={<AddUserPage />} />
        <Route exact path="/alert" element={<AlertPage />} />
        <Route exact path="/assign-role" element={<AssignRolePage />} />
        <Route exact path="/avatar" element={<AvatarPage />} />
        <Route exact path="/badges" element={<BadgesPage />} />
        <Route exact path="/button" element={<ButtonPage />} />
        <Route exact path="/calendar-main" element={<CalendarMainPage />} />
        <Route exact path="/calendar" element={<CalendarMainPage />} />
        <Route exact path="/card" element={<CardPage />} />
        <Route exact path="/carousel" element={<CarouselPage />} />
        <Route exact path="/chat-empty" element={<ChatEmptyPage />} />
        <Route exact path="/chat-message" element={<ChatMessagePage />} />
        <Route exact path="/chat-profile" element={<ChatProfilePage />} />
        <Route exact path="/code-generator" element={<CodeGeneratorPage />} />
        <Route
          exact
          path="/code-generator-new"
          element={<CodeGeneratorNewPage />}
        />
        <Route exact path="/colors" element={<ColorsPage />} />
        <Route exact path="/column-chart" element={<ColumnChartPage />} />

        <Route exact path="/currencies" element={<CurrenciesPage />} />
        <Route exact path="/dropdown" element={<DropdownPage />} />
        <Route exact path="/email" element={<EmailPage />} />
        <Route exact path="/faq" element={<FaqPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/form-layout" element={<FormLayoutPage />} />
        <Route exact path="/form-validation" element={<FormValidationPage />} />
        <Route exact path="/form" element={<FormPage />} />

        <Route exact path="/gallery" element={<GalleryPage />} />
        <Route exact path="/gallery-grid" element={<GalleryGridPage />} />
        <Route exact path="/gallery-masonry" element={<GalleryMasonryPage />} />
        <Route exact path="/gallery-hover" element={<GalleryHoverPage />} />

        <Route exact path="/blog" element={<BlogPage />} />
        <Route exact path="/blog-details" element={<BlogDetailsPage />} />
        <Route exact path="/add-blog" element={<AddBlogPage />} />

        <Route exact path="/testimonials" element={<TestimonialsPage />} />
        <Route exact path="/coming-soon" element={<ComingSoonPage />} />
        <Route exact path="/access-denied" element={<AccessDeniedPage />} />
        <Route exact path="/maintenance" element={<MaintenancePage />} />
        <Route exact path="/blank-page" element={<BlankPagePage />} />

        <Route exact path="/image-generator" element={<ImageGeneratorPage />} />
        <Route exact path="/image-upload" element={<ImageUploadPage />} />
        <Route exact path="/invoice-add" element={<InvoiceAddPage />} />
        <Route exact path="/invoice-edit" element={<InvoiceEditPage />} /> */}
        <Route
          exact
          path="/invoice-list"
          element={
            <ProtectedRoute>
              <InvoiceListPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/transaction/:id"
          element={
            <ProtectedRoute>
              <TransactionDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/transaction-by-user/:id"
          element={
            <ProtectedRoute>
              <TransactionByUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/deposits"
          element={
            <ProtectedRoute>
              <DepositPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/deposit/:id"
          element={
            <ProtectedRoute>
              <DepositDetailPage />
            </ProtectedRoute>
          }
        />
        <Route
          exact
          path="/deposit-by-user/:id"
          element={
            <ProtectedRoute>
              <DepositByUserPage />
            </ProtectedRoute>
          }
        />
        {/* <Route exact path="/invoice-preview" element={<InvoicePreviewPage />} />
        <Route exact path="/kanban" element={<KanbanPage />} />
        <Route exact path="/language" element={<LanguagePage />} />
        <Route exact path="/line-chart" element={<LineChartPage />} />
        <Route exact path="/list" element={<ListPage />} />
        <Route
          exact
          path="/marketplace-details"
          element={<MarketplaceDetailsPage />}
        />
        <Route exact path="/marketplace" element={<MarketplacePage />} />
        <Route
          exact
          path="/notification-alert"
          element={<NotificationAlertPage />}
        />
        <Route exact path="/notification" element={<NotificationPage />} />
        <Route exact path="/pagination" element={<PaginationPage />} />
        <Route exact path="/payment-gateway" element={<PaymentGatewayPage />} />
        <Route exact path="/pie-chart" element={<PieChartPage />} />
        <Route exact path="/portfolio" element={<PortfolioPage />} />
        <Route exact path="/pricing" element={<PricingPage />} />
        <Route exact path="/progress" element={<ProgressPage />} />
        <Route exact path="/radio" element={<RadioPage />} />
        <Route exact path="/role-access" element={<RoleAccessPage />} /> */}
        <Route
          exact
          path="/sign-in"
          element={
            <GuestRoute>
              <SignInPage />
            </GuestRoute>
          }
        />
        {/* <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/star-rating" element={<StarRatingPage />} />
        <Route exact path="/starred" element={<StarredPage />} />
        <Route exact path="/switch" element={<SwitchPage />} />
        <Route exact path="/table-basic" element={<TableBasicPage />} />
        <Route exact path="/table-data" element={<TableDataPage />} />
        <Route exact path="/tabs" element={<TabsPage />} />
        <Route exact path="/tags" element={<TagsPage />} />
        <Route exact path="/terms-condition" element={<TermsConditionPage />} />
        <Route
          exact
          path="/text-generator-new"
          element={<TextGeneratorNewPage />}
        />
        <Route exact path="/text-generator" element={<TextGeneratorPage />} />
        <Route exact path="/theme" element={<ThemePage />} />
        <Route exact path="/tooltip" element={<TooltipPage />} />
        <Route exact path="/typography" element={<TypographyPage />} />
        <Route exact path="/users-grid" element={<UsersGridPage />} /> */}
        <Route
          exact
          path="/users-list"
          element={
            <ProtectedRoute>
              <UsersListPage />
            </ProtectedRoute>
          }
        />
        {/* <Route exact path="/view-details" element={<ViewDetailsPage />} />
        <Route exact path="/video-generator" element={<VideoGeneratorPage />} />
        <Route exact path="/videos" element={<VideosPage />} /> */}
        <Route
          exact
          path="/profile/:id"
          element={
            <ProtectedRoute>
              <ViewProfilePage />
            </ProtectedRoute>
          }
        />
        <Route exact path="/voice-generator" element={<VoiceGeneratorPage />} />
        <Route
          exact
          path="/wallet"
          element={
            <ProtectedRoute>
              <WalletPage />
            </ProtectedRoute>
          }
        />
        {/* <Route exact path="/widgets" element={<WidgetsPage />} />
        <Route exact path="/wizard" element={<WizardPage />} /> */}

        <Route exact path="*" element={<ErrorPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
